import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";
import { Hud } from "./hud.js";

/**
 * The single seam between the game and React, mounted ONCE at boot into a
 * `pointer-events: none` overlay above the canvas. Everything the HUD draws
 * comes from `ui/store.ts`; everything it does comes through the callbacks
 * here.
 */

export interface HudHandle {
  /** Unmounts the HUD. Only used by teardown paths and tests. */
  dispose(): void;
}

export interface MountHudOptions {
  /** The overlay element — `#ui` in `index.html`. */
  container: HTMLElement;
  /** The death overlay's "Respawn" button. */
  onRespawn: () => void;
}

export function mountHud(opts: MountHudOptions): HudHandle {
  let root: Root | null = createRoot(opts.container);
  root.render(
    <StrictMode>
      <Hud onRespawn={opts.onRespawn} />
    </StrictMode>,
  );

  return {
    dispose(): void {
      const r = root;
      root = null;
      // Unmounting synchronously from inside a React lifecycle is illegal, and
      // this can be called from anywhere; defer it to be safe.
      if (r !== null) queueMicrotask(() => { r.unmount(); });
    },
  };
}
